import { FormattedMessage } from 'react-intl';

export type Props = {
    messageId: string;
    showUpselling?: boolean;
    upsellingUrl?: string;
};

export const WarningMessage = ({ messageId, showUpselling = false, upsellingUrl }: Props) => (
    <span className='display-flex gap-5 align-items-center text-color-gray' data-testid='no-data-position'>
        <span className='rioglyph rioglyph-warning-sign text-size-14' />
        <span
            className='white-space-nowrap margin-top-1 text-size-12 line-height-14 text-left'
            style={{ letterSpacing: '-0.2px !important' }}
        >
            <FormattedMessage id={messageId} />
        </span>
        {showUpselling && upsellingUrl && (
            <iframe
                title='srp-upselling'
                className='buyButton scale-90'
                src={upsellingUrl}
                style={{ height: '20px', transformOrigin: 'left' }}
            />
        )}
    </span>
);
